export default __webpack_public_path__ + "img/pin_icons/smoke_detector_b.png";